import React from 'react';
import { Chip } from '@material-ui/core';
import { USERSTATUS } from '../../../../../../constants/selects';
import commons from '../../../../../../assets/styles/commons';

interface StatusTagProps {
  status: string;
}

const StatusUser: React.FC<StatusTagProps> = ({ status }) => {
  const getStatusStyle = (status: string) => {
    if (status === 'Registro incompleto') {
      return {
        background: '#FFF3CD',
        color: '#856404',
        border: '1px solid #856404',
        borderRadius: '4px',
      };
    }

    switch (status) {
      case 'Ativo':
        return {
          background: '#E6FCD6',
          color: '#1A9A25',
          border: '1px solid #1A9A25',
          borderRadius: '4px',
        };
      default:
        return {
          background: '#F7F9FC',
          color: '#8F9BB3',
          border: '1px solid #8F9BB3',
          borderRadius: '4px',
        };
    }
  };

  const style = getStatusStyle(status);

  return (
    <Chip
      label={status}
      style={{
        background: style.background,
        color: style.color,
        border: style.border,
        borderRadius: style.borderRadius,
        fontFamily: commons.fontFamily,
        fontSize: 12,
      }}
    />
  );
};

export default StatusUser;
